module.exports = __webpack_public_path__ + "img/ico_user.c0e1d66b.svg";